export enum ProductRequestDetailContext {
  APPROVE = 'approve',
  REJECT = 'reject',
  PAID= 'paid',
  DISPENSE = 'dispense',
}
